
export function getAllPaths(state) {
  return state.paths;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/firekit/es/store/paths/selectors.js
// module id = 696
// module chunks = 49